import { Link, useLocation } from "react-router-dom";
import {
  X,
  Home,
  BarChart2,
  Settings,
  ChevronDown,
  ChevronUp,
  FileText,
  Folder,
  Globe,
  BookOpenIcon,
  UserIcon,
  PhoneCallIcon,
  HomeIcon,
} from "lucide-react"; // Updated icons
import { useState } from "react";
import { AiOutlineDown, AiOutlineUp } from "react-icons/ai"; // Arrow icons for dropdown
import logo from "../assets/digitalparag/DigirtalParag.png";
function Usidebar({ sidebarOpen, setSidebarOpen }) {
  const [reportDropdownOpen, setReportDropdownOpen] = useState(false);
  const location = useLocation(); // Get the current location

  // Function to determine if a link is active
  const isActive = (path) => location.pathname === path;
  const [isDropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setDropdownOpen(!isDropdownOpen);
  };

  const currentPath = location.pathname;
  const linkClasses = (path) => `
        flex items-center px-6 py-2 mt-2 text-white
        ${
          currentPath === path
            ? "bg-green-400 text-gray-700 font-semibold"
            : "hover:bg-orange-400"
        }
    `;
  return (
    <div
      className={`${
        sidebarOpen ? "translate-x-0" : "-translate-x-full"
      } fixed inset-y-0 left-0 z-50 w-52 text-white bg-black shadow-lg transform transition-transform duration-300 ease-in-out lg:translate-x-0 lg:static lg:inset-0`}
      style={{
        boxShadow: sidebarOpen ? "-4px 0px 15px #000000 !important" : "",
      }}
    >
      <div className="flex items-center justify-between h-16 bg-[#b0c22a] px-4">
        <Link to="/dashboard/dashboard" className="flex items-center">
          <img
            src={logo}
            alt="Digital Parag Logo"
            className="h-12 sm:h-14 md:h-16"
          />
        </Link>
        <button
          className="text-white focus:outline-none lg:hidden"
          onClick={() => setSidebarOpen(false)}
        >
          <X className="h-6 w-6" />
        </button>
      </div>
      <nav className="mt-3">
        <ul className="nav flex-column">
          <li className="nav-item">
            <Link
              // className="nav-link text-white active"
              // aria-current="page"
              to="/dashboard/dashboard"
              className={linkClasses("/dashboard/dashboard")}
            >
              Dashboard
            </Link>
          </li>
          <li className="nav-item dropdown">
            <Link
              to="/dashboard/user_incometax"
              className={linkClasses("/dashboard/user_incometax")}
              // className="nav-link text-white dropdown-toggle"
              // to="#"
              // id="ecommerceDropdown"
              // role="button"
              // data-bs-toggle="dropdown"
              // aria-expanded="false"
            >
              Income Tax
            </Link>
            {/* <ul className="dropdown-menu" aria-labelledby="ecommerceDropdown">
              <li>
                <Link className="dropdown-item" to="/dashboard/user_incometax">
                  All Data
                </Link>
              </li>

              <li>
                <Link
                  className="dropdown-item"
                  to="/dashboard/user_incometax_complete"
                >
                  Completed Work
                </Link>
              </li>
            </ul> */}
          </li>
          <li className="nav-item">
            <Link
              to="/dashboard/pension_proposal"
              className={linkClasses("/dashboard/pension_proposal")}
              // id="PensionProposal"
              // role="button"
              // data-bs-toggle="dropdown"
              // aria-expanded="false"
            >
              Pension Proposal
            </Link>
            {/* <ul className="dropdown-menu" aria-labelledby="PensionProposal">
              <li>
                <Link
                  className="dropdown-item"
                  to="/dashboard/pension_proposal"
                >
                  New
                </Link>
              </li>
              <li>
                <Link
                  className="dropdown-item"
                  to="/dashboard/pension_proposal_work"
                >
                  Completed Work
                </Link>
              </li>
            </ul> */}
          </li>
          {/* <li className="nav-item dropdown">
            <Link
              className="nav-link text-white dropdown-toggle"
              to="#"
              id="GPFFinal"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              GPF (Final)
            </Link>
            <ul className="dropdown-menu" aria-labelledby="GPFFinal">
              <li>
                <Link className="dropdown-item" to="/dashboard/profile">
                  New
                </Link>
              </li>
              <li>
                <Link className="dropdown-item" to="/dashboard/account">
                  Completed Work
                </Link>
              </li>
            </ul>
          </li>
          <li className="nav-item dropdown">
            <Link
              className="nav-link text-white dropdown-toggle"
              to="#"
              id="GISProposal"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              GIS Proposal
            </Link>
            <ul className="dropdown-menu" aria-labelledby="GISProposal">
              <li>
                <Link className="dropdown-item" to="/dashboard/profile">
                  New
                </Link>
              </li>
              <li>
                <Link className="dropdown-item" to="/dashboard/account">
                  Completed Work
                </Link>
              </li>
            </ul>
          </li> */}
          <li className="nav-item dropdown">
            <Link
              // className="nav-link text-white dropdown-toggle"
              // to="#"
              // id="InternDistrictTransfer"
              // role="button"
              // data-bs-toggle="dropdown"
              // aria-expanded="false"
              to="/dashboard/inter_district_transfer"
              className={linkClasses("/dashboard/inter_district_transfer")}
            >
              Inter District Transfer
            </Link>
            {/* <ul
              className="dropdown-menu"
              aria-labelledby="InternDistrictTransfer"
            >
              <li>
                <Link
                  className="dropdown-item"
                  to="/dashboard/inter_district_transfer"
                >
                  New
                </Link>
              </li>
              <li>
                <Link
                  className="dropdown-item"
                  to="/dashboard/inter_district_transfer_work"
                >
                  Completed Work
                </Link>
              </li>
            </ul> */}
          </li>
          <li className="nav-item dropdown">
            <Link
              // className="nav-link text-white dropdown-toggle"
              // to="#"
              // id="GPFNonRefundable"
              // role="button"
              // data-bs-toggle="dropdown"
              // aria-expanded="false"
              to="/dashboard/gpf_non_refundable"
              className={linkClasses("/dashboard/gpf_non_refundable")}
            >
              GPF (Non Refundable)
            </Link>
            {/* <ul className="dropdown-menu" aria-labelledby="GPFNonRefundable">
              <li>
                <Link
                  className="dropdown-item"
                  to="/dashboard/gpf_non_refundable"
                >
                  New
                </Link>
              </li>
              <li>
                <Link
                  className="dropdown-item"
                  to="/dashboard/gpf_non_refundable_work"
                >
                  Completed Work
                </Link>
              </li>
            </ul> */}
          </li>
          <li className="nav-item dropdown">
            <Link
              // className="nav-link text-white dropdown-toggle"
              // to="#"
              // id="GPFNonRefundable"
              // role="button"
              // data-bs-toggle="dropdown"
              // aria-expanded="false"
              to="/dashboard/voluntary_retirement_proposal"
              className={linkClasses(
                "/dashboard/voluntary_retirement_proposal"
              )}
            >
              VRS Notice
            </Link>
            {/* <ul className="dropdown-menu" aria-labelledby="GPFNonRefundable">
              <li>
                <Link
                  className="dropdown-item"
                  to="/dashboard/voluntary_retirement_proposal"
                >
                  New
                </Link>
              </li>
              <li>
                <Link
                  className="dropdown-item"
                  to="/dashboard/voluntary_retirement_proposal_work"
                >
                  Completed Work
                </Link>
              </li>
            </ul> */}
          </li>
        </ul>
        {/* <Link
          to="/admin/admin_dashboard"
          className={linkClasses("/admin/admin_dashboard")}
        >
          <HomeIcon className="h-5 w-5 mr-3" />
          Dashboard
        </Link>
        <Link
          to="/admin/users_data"
          className={linkClasses("/admin/users_data")}
        >
          <UserIcon className="h-5 w-5 mr-3" />
          User Data
        </Link>
        <Link
          to="/admin/contact_data"
          className={linkClasses("/admin/contact_data")}
        >
          <PhoneCallIcon className="h-5 w-5 mr-3" />
          Contact Data
        </Link>

        <Link
          to="/admin/add_pdf"
          className={linkClasses("/admin/add_pdf text-2xl text-black")}
        >
          <BookOpenIcon className="h-5 w-5 mr-3" />
          Add Govt Books & GR
        </Link>

        <Link
          to="/admin/change-year"
          className={linkClasses("/admin/add_pdf text-2xl text-black")}
        >
          <BookOpenIcon className="h-5 w-5 mr-3" />
          GPF Change Year
        </Link> */}
      </nav>
    </div>
    // <div
    //   className={`${sidebarOpen ? 'translate-x-0' : '-translate-x-full'
    //     } fixed inset-y-0 left-0 z-50 w-64 bg-blue-100 shadow-lg transform transition-transform duration-300 ease-in-out lg:translate-x-0 lg:static lg:inset-0`}
    // >
    //   <div className="flex items-center justify-between h-16 bg-[#b0c22a] px-4">
    //     <span className="text-white text-2xl font-bold text-center">User Panel</span>
    //     <button className="text-white focus:outline-none lg:hidden" onClick={() => setSidebarOpen(false)}>
    //       <X className="h-6 w-6" />
    //     </button>
    //   </div>
    // </div>
  );
}

export default Usidebar;
